import { TimeEntryBookingDTO } from './timeEntryBookingDTO'

/**
 * Represents the response containing multiple bookings the candidate can clock into.
 */
export class TimeEntryBookingsResponse {
  /**
   * @param {Object} responseData - The response data object.
   * @param {Array<Object>} responseData.bookings - Array of raw booking data objects.
   */
  constructor(responseData) {
    /**
     * Array of booking entries.
     * @type {TimeEntryBookingDTO[]}
     */
    this.bookings = responseData.bookings.map(
      (booking) => new TimeEntryBookingDTO(booking)
    )
  }
}
